export default {
  tenantPdfTemplates(state) {
    return state.tenantPdfTemplates
  },
}
